function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedSofaBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04 9.01c-.56 0-1.013.454-1.013 1.013v3.467H4v-3.467a3.04 3.04 0 013.04-3.04h17.92a3.04 3.04 0 013.04 3.04v3.467h-2.026v-3.467c0-.56-.454-1.013-1.014-1.013H7.04z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.989 15.103a2 2 0 012-2h2.337a2 2 0 012 2v1.524h15.348v-1.524a2 2 0 012-2h2.338a2 2 0 012 2v7.403h-2v-7.403h-2.338v3.524H6.326v-3.524H3.989v7.403h-2v-7.403z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.47 22.506H3.53v-2h24.94v2z",
    fill: props.color
  }));
}

export default SvgIconBedSofaBedFilled;